/**
 * Working hours utility
 * Checks if the current time in Turkey (UTC+3) is within working hours.
 *
 * Working hours:
 * - Monday to Friday: 09:00 - 18:00
 * - Saturday: 10:00 - 15:00
 * - Sunday: Closed
 */

export const checkIsWorkingHours = () => {
    // Get current Turkey time (UTC+3)
    const now = new Date();
    const turkeyTime = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Istanbul' }));

    const day = turkeyTime.getDay(); // 0=Sunday, 1=Monday, ..., 6=Saturday
    const hours = turkeyTime.getHours();
    const minutes = turkeyTime.getMinutes();
    const currentTime = hours * 60 + minutes; // Convert to minutes for easier comparison

    // Sunday (0) = Closed
    if (day === 0) return false;

    // Monday to Friday (1-5): 09:00 - 18:00
    if (day >= 1 && day <= 5) {
        return currentTime >= 9 * 60 && currentTime < 18 * 60;
    }

    // Saturday (6): 10:00 - 15:00
    if (day === 6) {
        return currentTime >= 10 * 60 && currentTime < 15 * 60;
    }

    return false;
};

export const getWorkingHoursMessage = () => {
    return "⏰ Havale ile ödeme sadece mesai saatlerinde (Hafta içi 09:00-18:00, Cumartesi 10:00-15:00) mümkündür.";
};
